import React, { useEffect, useState } from 'react'
import { components, constants, useServices, useTranslation } from 'cng-web-lib'
import AceHighwayResponseApiUrls from 'src/apiUrls/AceHighwayResponseApiUrls'
import AceHighwayKeys from 'src/constants/locale/key/AceHighwayResponse'
import Namespace from 'src/constants/locale/Namespace'
import moment from 'moment-timezone'
import {
  Box,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography
} from '@material-ui/core'
import clsx from 'clsx'
import ACEHighwayResponseTranslationText from 'src/views/acehighway/contexts/ACEHighwayResponseTranslationText'
import NaCommonTranslationText from 'src/common/NaCommonTranslationText'

const {
  table: { useFetchCodeMaintenanceLookup }
} = components

const {
  filter: { EQUAL, IN }
} = constants

const useStyles = makeStyles((theme) => ({
  table: {
    '& .MuiTableHead-root': {
      backgroundColor: theme.palette.background.sectionOddBg,
      '& .MuiTableCell-head': {
        borderBottom: 0,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        textTransform: 'uppercase'
      }
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        '&:last-child': {
          '& .MuiTableCell-root': {
            borderBottom: 0
          }
        }
      }
    },
    '& .MuiTableCell-root': {
      padding: '8px 16px'
    }
  }
}))

function TripResponse(props) {
  const { showNotification, id, isViewOnly = false } = props

  const [data, setData] = useState([])
  const [lookups, setLookups] = useState(null)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const { fetchRecords } = useServices()
  const { translate } = useTranslation([Namespace.ACE_HIGHWAY_RESPONSE])
  //const translatedTextsObject = makeTranslatedTextsObject()
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const classes = useStyles()

  const aceHighwayResponseTranslationText = ACEHighwayResponseTranslationText()    
  const naCommonTranslationText = NaCommonTranslationText()
  

  useEffect(() => {
    Promise.all([
      fetchRecords.execute(
        AceHighwayResponseApiUrls.GET,
        {
          filters: [
            {
              field: 'headerId',
              operator: EQUAL,
              value: id
            },
            {
              field: 'documentType',
              operator: IN,
              value: ['ACE_TRIP','ACE_TRIP_SN']
            }
          ]
        },
        (res) => res.content
      ),
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [
          {
            field: 'codeType',
            operator: EQUAL,
            value: 'ACE_HW_MAN_SUBM_ACTION'
          }
        ],
        undefined,
        'code'
      )
    ]).then(([data, submissionType]) => {
      setData(data)
      setLookups({ submissionType })
    })
  }, [])

  /*function makeTranslatedTextsObject() {
    let cbsaProcessingDate = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.CBSA_PROCESSING_DATE
    )
    let CBPRefNo = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.CBP_REF_NO
    )
    let tripNo = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.TRIP_NO
    )
    let responseCode = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.RESPONSE_CODE
    )
    let responseText = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.RESPONSE_TEXT
    )
    let shipmentControlNo = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.SHIPMENT_CONTROL_NO
    )
    let responseDate = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.RESPONSE_DATE
    )
    let submissionType = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.SUBMISSION_TYPE
    )
    let submitId = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.SUBMIT_ID
    )
    let methodOfSubmission = translate(
      Namespace.ACE_HIGHWAY_RESPONSE,
      AceHighwayKeys.METHOD
    )

    return {
      cbsaProcessingDate,
      CBPRefNo,
      tripNo,
      responseCode,
      responseText,
      shipmentControlNo,
      responseDate,
      submissionType,
      submitId,
      methodOfSubmission
    }
  }*/ 

  const columns = [
    {
      title: aceHighwayResponseTranslationText.cbsaProcessingDate,
      render: (data) =>
        data.cbsaProcessingDate &&
        moment(data.cbsaProcessingDate).tz("Canada/Eastern").format('D MMM YYYY - HH:mm')
    },
    { field: 'cbpRefNo', title: aceHighwayResponseTranslationText.CBPRefNo },
    { field: 'responseCode', title: aceHighwayResponseTranslationText.responseCode },
    { field: 'responseText', title: aceHighwayResponseTranslationText.responseText },
    {
      title: `${aceHighwayResponseTranslationText.tripNo} & ${aceHighwayResponseTranslationText.shipmentControlNo}`,
      render: (data) => [data.tripNo, data.shipmentControlNo].join(', ')
    },
    {
      title: aceHighwayResponseTranslationText.responseDate,
      render: (data) =>
        data.responseDate &&
        moment(data.responseDate).tz("Canada/Eastern").format('D MMM YYYY - HH:mm')
    },
    {
      title: aceHighwayResponseTranslationText.submissionType,
     render: (data) =>
       lookups
         ? lookups['submissionType'][data.submissionType]
         : data.submissionType
   },
   { field: 'submitId',
   title: aceHighwayResponseTranslationText.submitId,
   render: (data) => data.submitId }, 
   { field: 'methodOfSubmission',
   title: aceHighwayResponseTranslationText.methodOfSubmission,
   render: (data) => data.methodOfSubmission } 
    
  ]

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value)
    setPage(0)
  }

  return (
    <>
      <TableContainer>
        <Table className={clsx(classes.table, 'new-ui-table-component__table')}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell key={index}>{column.title}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((d) => (
                  <TableRow key={d.id}>
                    {columns.map((column, index) => (
                      <TableCell key={index}>
                        {column.render ? column.render(d) : d[column.field]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell
                  align='center'
                  colSpan={columns.length}
                >
                  <Typography variant='body2' color='textSecondary'>
                    {naCommonTranslationText.noRecordsMessage}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Box padding={2}>
        <TablePagination
          rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
          component='div'
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Box>
    </>
  )
}

export default TripResponse
